import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './initStore';

export interface ISearchState {
    isOnSearch: boolean;
}

export const searchSlice = createSlice({
    name: 'searchState',
    initialState: {
        isOnSearch: false,
    } as ISearchState,
    reducers: {
        changeIsOnSearch: (state, action: PayloadAction<boolean>) => {
            state.isOnSearch = action.payload;
        },
    },
});

export const { changeIsOnSearch } = searchSlice.actions;
export const isOnSearchState = (state: IGlobalStoreReducers) => state.searchState.isOnSearch;

export default searchSlice.reducer;
